import React, { useState } from "react";
import "./ExpandableApplicationSection.css";

const ExpandableApplicationSection = ({ label, closeLabel, children }) => {
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const toggle = () => {
    setOpen((current) => {
      if (!current) setHasOpened(true);
      return !current;
    });
  };

  return (
    <section className={`expandable-application-section ${open ? "open" : "closed"}`}>
      <button type="button" className="expandable-application-toggle" aria-expanded={open} onClick={toggle}>
        <span aria-hidden="true">{open ? "−" : "+"}</span>
        {open ? closeLabel : label}
      </button>
      {hasOpened && (
        <div className="expandable-application-region" aria-hidden={!open} inert={open ? undefined : ""}>
          <div className="expandable-application-content">{children}</div>
        </div>
      )}
    </section>
  );
};

export default ExpandableApplicationSection;
